document.addEventListener('DOMContentLoaded', function () {
    const page = document.querySelector('.test-page')
    const form = document.querySelector('.test-page.start.hidden')
    const btn_next = document.querySelector('.test-form__next')
    const btn_back = document.querySelector('.test-form__back')
    const text_btn_next = 'Следующий шаг'
    const text_btn_close = 'Завершить'
    let stepValue = 0

    //* start
    document.querySelector('#start-test').addEventListener('click', (e) => {
        e.preventDefault()
        page.classList.add('hidden')
        form.classList.remove('hidden')
        stepValue = 1
        changeStep(stepValue)
    })

    btn_next.addEventListener('click', (e) => {
        e.preventDefault()
        if (stepValue <= 3) {
            if (validateStep(stepValue)) {
                stepValue = stepValue + 1 
                changeStep(stepValue)
            }
        } else if (stepValue === 4) {
            if (validateStep(stepValue)) {
                let url = e.target.getAttribute('data-url')
                let name = document.querySelector('.test-form__input')

                if (url && name) {
                    url = url.replace(/\/$/, '');
                    window.location.href = `${url}/?user-name=${encodeURIComponent(name.value)}`;
                }
            }
        }
    })

    btn_back.addEventListener('click', (e) => {
        e.preventDefault()
        if (stepValue > 1) {
            changeStep(--stepValue)
        }
    })

    function changeStep(step) {
        document.querySelector('.test-form__go-first').textContent = step.toString()
        document.querySelectorAll('.test-form__stage').forEach(function (item, index) {
            if (item.getAttribute('data-step') === step.toString()) {
                item.classList.add('active')
            }
            else {
                item.classList.remove('active')
            }
        })

        document.querySelectorAll('.test-page.start .test-page__img').forEach(function (item) {
            if (item.getAttribute('data-step') === step.toString()) {
                item.classList.remove('hidden')
            }
            else {
                item.classList.add('hidden')
            }
        })

        let line = document.querySelectorAll('.test-form__step div')
        line.forEach((item, key) => {

            if (++key <= step) {
                item.classList.add('full')
            } else {
                item.classList.remove('full')
            }

        })

        if (step === 1) {
            btn_back.classList.add('hidden')
        } else {
            btn_back.classList.remove('hidden')
        }

        if (step === 4) {
            btn_next.textContent = text_btn_close
        } else {
            btn_next.textContent = text_btn_next
        }
    }

    function validateStep(step) {

        console.log(step)
        
        let stage = document.querySelector('.test-form__stage[data-step="' + step +'"]')
        let radioStep = stage.querySelector('.test-form__radio-input[type="radio"]:checked') ? true : false
        let inputStep = stage.querySelector('.test-form__input[type="text"]') 

        if (radioStep) {
            stage.classList.remove('error')
            return true
        }
        if (inputStep && inputStep.value != '') {
            stage.classList.remove('error')
            return true
        }
        
        stage.classList.add('error')
        return false
    }
})